import { Numeric7BoxOutlineIcon } from './Numeric7BoxOutlineIcon';

/**
 * author: Google
 * id 373DD873-E15F-4B7C-8328-76389DC81DB0
 * name numeric-7-box-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-7-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number7BoxOutlineIcon = Numeric7BoxOutlineIcon;
export default Number7BoxOutlineIcon